/* Sami Jewels Holiday Homepage 2026 (hh26-v1) */
(function () {
  'use strict';
  if (window.__sjhhInit) return; window.__sjhhInit = true;

  function money(cents) {
    var v = (cents / 100);
    var s = v % 1 === 0 ? v.toFixed(0) : v.toFixed(2);
    return '$' + s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function initRoot(root) {
    if (!root || root.dataset.sjhhBound) return; root.dataset.sjhhBound = '1';

    /* Tabs */
    var tabs = root.querySelectorAll('[data-sjhh-tab]');
    var shopAll = root.querySelector('[data-sjhh-shopall]');
    function selectTab(key, focus) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-sjhh-tab') === key;
        t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        if (on && focus) t.focus();
      });
      root.querySelectorAll('[data-sjhh-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sjhh-panel') !== key; });
      if (shopAll) {
        shopAll.href = shopAll.getAttribute(key === 'new' ? 'data-new-href' : 'data-bs-href');
        shopAll.textContent = shopAll.getAttribute(key === 'new' ? 'data-new-label' : 'data-bs-label');
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectTab(t.getAttribute('data-sjhh-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          var n = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          selectTab(n.getAttribute('data-sjhh-tab'), true); e.preventDefault();
        }
      });
    });

    /* Choose options -> quick view */
    root.querySelectorAll('[data-sjhh-choose]').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = b.closest('.sjhh-card'); var raw = card && card.querySelector('[data-sjhh-product]');
        if (!raw) return;
        try { QV.open(JSON.parse(raw.textContent), b); } catch (e) { var a = card.querySelector('a'); if (a) location.href = a.href; }
      });
    });

    /* sj-mobile-ticker-1793304313: the strip itself is the phone pause control. */
    var trust = root.querySelector('.sjhh-trust'), pauseTrust = root.querySelector('[data-sjhh-trust-pause]');
    if (trust && pauseTrust) {
      var reduceTrust = window.matchMedia('(prefers-reduced-motion: reduce)');
      var phoneTrust = window.matchMedia('(max-width: 639px)');
      var userPausedTrust = false;
      var phonePauseTrust = document.createElement('button');
      phonePauseTrust.type = 'button';
      phonePauseTrust.className = 'sjhh-trust__mobile-toggle';
      phonePauseTrust.title = 'Tap to pause or resume scrolling benefits';
      phonePauseTrust.setAttribute('data-sjhh-mobile-trust-pause', '');
      trust.appendChild(phonePauseTrust);
      trust.dataset.sjhhMobileTicker = '1793304313';
      function renderTrustMotion() {
        var paused = reduceTrust.matches || userPausedTrust;
        trust.classList.toggle('is-paused', paused);
        pauseTrust.hidden = reduceTrust.matches;
        phonePauseTrust.hidden = reduceTrust.matches || !phoneTrust.matches;
        pauseTrust.textContent = paused ? 'Play' : 'Pause';
        [pauseTrust, phonePauseTrust].forEach(function (control) {
          control.setAttribute('aria-pressed', paused ? 'true' : 'false');
          control.setAttribute('aria-label', paused ? 'Play moving benefits' : 'Pause moving benefits');
        });
      }
      function toggleTrustMotion() {
        if (reduceTrust.matches) return;
        userPausedTrust = !userPausedTrust;
        renderTrustMotion();
      }
      pauseTrust.addEventListener('click', toggleTrustMotion);
      phonePauseTrust.addEventListener('click', toggleTrustMotion);
      reduceTrust.addEventListener('change', renderTrustMotion);
      phoneTrust.addEventListener('change', renderTrustMotion);
      renderTrustMotion();
    }
    initReviews(root);

    // An announcement link from another page arrives before the footer template exists.

  }

  /* ---------- Reviews ---------- */
  function initReviews(root) {
    var box = root.querySelector('[data-sjhh-reviews]'); if (!box) return;
    var dots = box.querySelector('[data-sjhh-rv-dots]'), stage = box.querySelector('.sjhh-rv__stage');
    var play = box.querySelector('[data-sjhh-rv-auto]');
    var list = []; try { list = JSON.parse(box.querySelector('[data-sjhh-rv-fallback]').textContent) || []; } catch (e) {}
    list = list.filter(function (r) { return r && r.quote; });
    var idx = 0, slides = [], timer = null, manuallyPaused = false;
    var hovered = false, focusInside = false, inView = false, scrollFrame = null;
    var phone = window.matchMedia('(max-width: 639px)');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    box.dataset.sjhhReviewVersion = '1793304447';
    function label(n) { n = (n || '').trim(); return (!n || n === 'Verified Buyer') ? 'Sami Jewels customer' : n; }
    function syncDots() {
      dots.querySelectorAll('button').forEach(function (d, k) {
        d.setAttribute('aria-current', k === idx ? 'true' : 'false');
      });
      box.dataset.sjhhReviewIndex = String(idx);
    }
    function schedule() {
      clearTimeout(timer); timer = null;
      var running = !phone.matches && !reduced.matches && !manuallyPaused &&
        !hovered && !focusInside && inView && !document.hidden && list.length > 1;
      box.dataset.sjhhReviewAutoplay = running ? 'running' : 'stopped';
      play.hidden = phone.matches || reduced.matches || list.length < 2;
      play.textContent = manuallyPaused ? 'Play reviews' : 'Pause reviews';
      play.setAttribute('aria-pressed', manuallyPaused ? 'true' : 'false');
      play.setAttribute('aria-label', manuallyPaused ? 'Play reviews' : 'Pause reviews');
      if (running) timer = setTimeout(function () { show(idx + 1, false); }, 8000);
    }
    function show(i, manual) {
      if (!list.length) return;
      idx = (i + list.length) % list.length;
      stage.setAttribute('aria-live', manual && !phone.matches ? 'polite' : 'off');
      slides.forEach(function (slide, k) {
        slide.hidden = !phone.matches && k !== idx;
        slide.classList.toggle('is-active', k === idx);
      });
      syncDots();
      if (phone.matches) stage.scrollTo({
        left: slides[idx].offsetLeft,
        behavior: manual && !reduced.matches ? 'smooth' : 'instant'
      });
      schedule();
    }
    function build() {
      clearTimeout(timer);
      stage.innerHTML = ''; dots.innerHTML = ''; slides = [];
      list.forEach(function (row, k) {
        var slide = document.createElement('div');
        slide.className = 'sjhh-rv__slide';
        slide.setAttribute('role', 'group');
        slide.setAttribute('aria-roledescription', 'slide');
        slide.setAttribute('aria-label', 'Review ' + (k + 1) + ' of ' + list.length);
        var quote = document.createElement('blockquote');
        quote.className = 'sjhh-rv__q'; quote.setAttribute('data-sjhh-rv-q', '');
        quote.textContent = '“' + row.quote + '”';
        var who = document.createElement('div');
        who.className = 'sjhh-rv__who'; who.setAttribute('data-sjhh-rv-who', '');
        who.textContent = label(row.name);
        slide.appendChild(quote); slide.appendChild(who); stage.appendChild(slide); slides.push(slide);
        var dot = document.createElement('button');
        dot.type = 'button'; dot.className = 'sjhh-rv__dot';
        dot.setAttribute('aria-label', 'Show review ' + (k + 1));
        dot.appendChild(document.createElement('span'));
        dot.addEventListener('click', function () { show(k, true); });
        dots.appendChild(dot);
      });
      idx = Math.min(idx, Math.max(0, list.length - 1));
      show(idx, false);
    }
    play.addEventListener('click', function () { manuallyPaused = !manuallyPaused; schedule(); });
    box.addEventListener('mouseenter', function () {
      hovered = window.matchMedia('(hover: hover) and (pointer: fine)').matches && !phone.matches; schedule();
    });
    box.addEventListener('mouseleave', function () { hovered = false; schedule(); });
    box.addEventListener('focusin', function () { focusInside = true; schedule(); });
    box.addEventListener('focusout', function () {
      requestAnimationFrame(function () { focusInside = box.contains(document.activeElement); schedule(); });
    });
    stage.addEventListener('keydown', function (e) {
      var next = e.key === 'ArrowRight' ? idx + 1 : e.key === 'ArrowLeft' ? idx - 1 :
        e.key === 'Home' ? 0 : e.key === 'End' ? list.length - 1 : null;
      if (next !== null) { e.preventDefault(); show(next, true); }
    });
    stage.addEventListener('scroll', function () {
      if (!phone.matches || scrollFrame) return;
      scrollFrame = requestAnimationFrame(function () {
        scrollFrame = null;
        var nearest = 0, distance = Infinity;
        slides.forEach(function (slide, k) {
          var delta = Math.abs(slide.offsetLeft - stage.scrollLeft);
          if (delta < distance) { distance = delta; nearest = k; }
        });
        idx = nearest; syncDots();
      });
    }, { passive: true });
    function modeChanged() {
      hovered = false;
      requestAnimationFrame(function () { show(idx, false); });
    }
    phone.addEventListener('change', modeChanged);
    reduced.addEventListener('change', modeChanged);
    document.addEventListener('visibilitychange', schedule);
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.target && e.target.contains(box)) clearTimeout(timer);
    });
    if ('IntersectionObserver' in window) {
      var visibility = new IntersectionObserver(function (entries) {
        inView = entries.some(function (e) { return e.isIntersecting; }); schedule();
      }, { threshold: 0.15 });
      visibility.observe(box);
    } else inView = true;
    build();
    if (box.getAttribute('data-live') === 'true' && box.dataset.stampedKey) {
      var url = 'https://stamped.io/api/widget/reviews?apiKey=' + encodeURIComponent(box.dataset.stampedKey) + '&storeUrl=' + encodeURIComponent(box.dataset.stampedStore) + '&sId=' + encodeURIComponent(box.dataset.stampedSid || '') + '&minRating=5&take=60&page=1';
      var load = function () {
        fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (d) {
          var rows = (d && d.data) || [];
          var live = rows.filter(function (r) {
            var m = (r.reviewMessage || '').replace(/\s+/g, ' ').trim();
            return r.reviewRating === 5 && m.length >= 50 && m.length <= 190 && !/https?:|www\.|<|>/i.test(m) && !/\b(but|however|wish|unfortunately|broke|tarnish|return|refund|disappoint|sparkle)\b/i.test(m);
          }).slice(0, 8).map(function (r) {
            var m = (r.reviewMessage || '').replace(/\s+/g, ' ').trim();
            var first = (r.author || '').trim().split(/\s+/)[0] || '';
            if (first.length < 2 || /\d|@/.test(first)) first = '';
            return { quote: m, name: first ? first.charAt(0).toUpperCase() + first.slice(1) : 'Sami Jewels customer' };
          });
          if (live.length >= 3) { list = live; build(); box.setAttribute('data-sjhh-reviews-source', 'stamped'); }
        }).catch(function () {});
      };
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) { if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); load(); } }, { rootMargin: '600px' });
        io.observe(box);
      } else load();
    }
  }


  /* ---------- Quick view ---------- */
  var QV = (function () {
    var el, dialog, img, nameEl, priceEl, optsEl, addBtn, msgEl, addedEl, sumEl, fullEl, opener, product, sel, linked = {}, busy = false, generation = 0;
    function q(s) { return el.querySelector(s); }
    function setup() {
      if (el) return true;
      el = document.querySelector('[data-sjhh-qv]'); if (!el) return false;
      document.body.appendChild(el); // escape any transformed/contained ancestor
      dialog = q('.sjhh-qv__dialog'); img = q('[data-sjhh-qv-img]'); nameEl = q('[data-sjhh-qv-name]'); priceEl = q('[data-sjhh-qv-price]');
      optsEl = q('[data-sjhh-qv-opts]'); addBtn = q('[data-sjhh-qv-add]'); msgEl = q('[data-sjhh-qv-msg]'); addedEl = q('[data-sjhh-qv-added]'); sumEl = q('[data-sjhh-qv-sum]'); fullEl = q('[data-sjhh-qv-full]');
      el.querySelectorAll('[data-sjhh-qv-close]').forEach(function (b) { b.addEventListener('click', close); });
      addBtn.addEventListener('click', add);
      document.addEventListener('keydown', function (e) {
        if (el.hidden) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        if (e.key === 'Tab') {
          var f = Array.prototype.filter.call(dialog.querySelectorAll('a[href],button:not([disabled]),input,[tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
          if (!f.length) return; var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
          else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
        }
      });
      return true;
    }
    function realOptions(p) { return (p.options || []).filter(function (o) { return !(o.name === 'Title' && o.values.length === 1 && /default title/i.test(o.values[0].v)); }); }
    function findVariant() {
      var opts = realOptions(product);
      if (!opts.length) return product.variants[0];
      return product.variants.find(function (v) { return opts.every(function (o, i) { return v.options[i] === sel[o.name]; }); });
    }
    function availableWith(optIndex, value) {
      var opts = realOptions(product);
      return product.variants.some(function (v) {
        if (!v.available || v.options[optIndex] !== value) return false;
        return opts.every(function (o, i) { return i === optIndex || !sel[o.name] || v.options[i] === sel[o.name]; });
      });
    }
    function render() {
      nameEl.textContent = product.name; fullEl.href = product.url;
      if (product.image) { img.src = product.image; img.alt = product.name; }
      var opts = realOptions(product);
      optsEl.innerHTML = '';
      opts.forEach(function (o, oi) {
        var fs = document.createElement('fieldset'); fs.className = 'sjhh-qv__opt';
        var lg = document.createElement('legend'); lg.className = 'sjhh-qv__legend'; lg.textContent = o.name;
        var picked = document.createElement('span'); picked.textContent = sel[o.name] || ''; lg.appendChild(picked); fs.appendChild(lg);
        var vals = document.createElement('div'); vals.className = 'sjhh-qv__vals';
        o.values.forEach(function (val) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'sjhh-qv__val'; b.textContent = val.v;
          var isLinked = val.url && val.url.split('?')[0] !== product.url.split('?')[0];
          b.setAttribute('aria-pressed', sel[o.name] === val.v ? 'true' : 'false');
          if (!isLinked && !availableWith(oi, val.v)) { b.classList.add('is-out'); b.setAttribute('aria-label', val.v + ' (sold out)'); }
          b.addEventListener('click', function () { pick(o.name, val, isLinked); });
          vals.appendChild(b);
        });
        fs.appendChild(vals); optsEl.appendChild(fs);
      });
      var missing = opts.find(function (o) { return !sel[o.name]; });
      var v = missing ? null : findVariant();
      priceEl.textContent = money(v ? v.price : product.price);
      msgEl.textContent = '';
      if (missing) { addBtn.disabled = true; addBtn.textContent = 'Select ' + missing.name.toLowerCase(); }
      else if (!v || !v.available) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
      else { addBtn.disabled = false; addBtn.textContent = 'Add to Bag · ' + money(v.price); }
    }
    function pick(name, val, isLinked) {
      if (!isLinked) { sel[name] = val.v; render(); return; }
      var url = val.url.split('?')[0], requestGeneration = generation;
      var go = function (data) { product = data; sel[name] = val.v; render(); };
      if (linked[url]) return go(linked[url]);
      addBtn.disabled = true; addBtn.textContent = 'Loading…'; optsEl.querySelectorAll('button').forEach(function(b){b.disabled=true;});
      fetch(url + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (d) {
        if (requestGeneration !== generation || el.hidden) return;
        var data = {
          name: d.title || product.name, url: url, image: (d.featured_image ? (d.featured_image.indexOf('//') === 0 ? 'https:' + d.featured_image : d.featured_image) : product.image), price: d.price,
          options: (d.options || []).map(function (o) { return { name: o.name, values: (o.values || []).map(function (x) { var same = product.options.find(function (po) { return po.name === o.name; }); var m = same && same.values.find(function (pv) { return pv.v === x; }); return { v: x, url: m ? (m.url && m.url.split('?')[0] === product.url.split('?')[0] ? product.url : m.url) : '' }; }) }; }),
          variants: (d.variants || []).map(function (v) { return { id: v.id, options: v.options, available: v.available, price: v.price }; })
        };
        // Option value URLs from the linked product's perspective: mark the original product's value as linked back
        data.options.forEach(function (o) { o.values.forEach(function (x) { if (x.url && x.url.split('?')[0] === url) x.url = ''; }); });
        linked[url] = data; go(data);
      }).catch(function () { if (requestGeneration === generation && !el.hidden) location.href = url; });
    }
    function add() {
      var v = findVariant(); if (!v || !v.available || busy) return;
      busy = true; addBtn.disabled = true; optsEl.querySelectorAll('button').forEach(function(b){b.disabled=true;}); addBtn.classList.add('is-busy'); addBtn.textContent = 'Adding…';
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to bag'); return j; }); })
        .then(function () {
          var opts = realOptions(product);
          sumEl.textContent = opts.map(function (o) { return sel[o.name]; }).filter(Boolean).join(' · ') || product.name;
          refreshCart();
          /* With Rebuy Smart Cart (the store's cart drawer) present, its drawer is the add-to-bag confirmation: close the quick view, refresh Rebuy, make sure the drawer is open. hh26-v2 */
          if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') {
            opener = null; close();
            var shown = function () { return !!document.querySelector('#rebuy-cart.is-visible'); };
            var p; try { p = Rebuy.Cart && typeof Rebuy.Cart.fetchCart === 'function' ? Rebuy.Cart.fetchCart() : null; } catch (e) { p = null; }
            Promise.resolve(p).catch(function () {}).then(function () { setTimeout(function () { if (!shown()) { try { Rebuy.SmartCart.show(); } catch (e) {} } }, 300); });
            return;
          }
          optsEl.hidden = true; addBtn.hidden = true; addedEl.hidden = false;
          var vb = addedEl.querySelector('.sjhh-qv__view'); if (vb) vb.focus();
        })
        .catch(function (err) { msgEl.textContent = err.message || 'Could not add to bag. Please try again.'; render(); msgEl.textContent = err.message || 'Could not add to bag.'; })
        .finally(function () { busy = false; addBtn.classList.remove('is-busy'); optsEl.querySelectorAll('button').forEach(function(b){b.disabled=false;}); if (el && !el.hidden && addedEl.hidden) { var err = msgEl.textContent; render(); msgEl.textContent = err; } });
    }
    function refreshCart() {
      fetch('/cart.js?sjhh=' + Date.now(), { cache: 'no-store', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
        document.querySelectorAll('#cart-icon-bubble .count_item, #cart-icon-bubble [class*="count"], [data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; n.hidden = false; n.classList.remove('hidden'); n.style.removeProperty('display'); });
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } })); } catch (e) {}
        try { if (window.Alpine && Alpine.store && Alpine.store('xCartHelper') && Alpine.store('xCartHelper').reRenderSections) Alpine.store('xCartHelper').reRenderSections(); } catch (e) {}
        /* Rebuy.Cart.fetchCart() is intentionally not called here: it pops the Rebuy drawer over the quick view. */
      }).catch(function () {});
    }
    function open(data, from) {
      if (!setup()) return;
      generation++; opener = from; product = data; sel = {}; linked = {};
      var opts = realOptions(product);
      opts.forEach(function (o) { if (o.values.length === 1) sel[o.name] = o.values[0].v; });
      optsEl.hidden = false; addBtn.hidden = false; addedEl.hidden = true;
      render();
      el.hidden = false; document.documentElement.classList.add('sjhh-qv-open');
      setTimeout(function () { var x = el.querySelector('.sjhh-qv__x'); if (x) x.focus(); }, 30);
    }
    function close() {
      if (!el || el.hidden) return;
      generation++; el.hidden = true; document.documentElement.classList.remove('sjhh-qv-open');
      if (opener && opener.focus) opener.focus();
    }
    return { open: open, close: close };
  })();

  function boot() { document.querySelectorAll('.sjhh[data-sjhh-version]').forEach(initRoot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { window.__sjhhInit && boot(); });
})();
